import { Control, Controller } from 'react-hook-form';

import { AutocompleteInput } from '..';
import { Option } from '../inputs/AutocompleteInput';

export interface FormAutocompleteInputProps {
  name: string;
  placeholder: string;
  control: Control<any>;
  value?: Option | null;
  onChange: (newValue: Option | null) => void;
  onInputChange: (newValue: string) => void;
  options: Option[];
  required?: boolean;
  disabled?: boolean;
  loading?: boolean;
  showTypingLengthHint?: boolean;
}

const FormAutocompleteInput = ({
  name,
  placeholder,
  control,
  value,
  onChange,
  onInputChange,
  options,
  required = false,
  disabled = false,
  loading = false,
  showTypingLengthHint = true,
}: FormAutocompleteInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState }) => (
        <AutocompleteInput
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          options={options}
          required={required}
          disabled={disabled}
          loading={loading}
          showTypingLengthHint={showTypingLengthHint}
          error={!!fieldState.error}
          errorInfo={fieldState.error?.message || ''}
        />
      )}
    />
  );
};

export default FormAutocompleteInput;
